import { render, staticRenderFns } from "./ApproveDetailModal.vue?vue&type=template&id=6f7561d0&scoped=true"
import script from "./ApproveDetailModal.vue?vue&type=script&lang=js"
export * from "./ApproveDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7561d0",
  null
  
)

export default component.exports